import { render, staticRenderFns } from "./surface_post_moderation.vue?vue&type=template&id=df8c9278&scoped=true&"
import script from "./surface_post_moderation.vue?vue&type=script&lang=js&"
export * from "./surface_post_moderation.vue?vue&type=script&lang=js&"
import style0 from "./surface_post_moderation.vue?vue&type=style&index=0&id=df8c9278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8c9278",
  null
  
)

export default component.exports